<!-- src/components/login.vue -->
<template>
  <div class="login-page">
    <van-nav-bar title="用户登录" left-text="返回" @click-left="$router.back()" />
    <div class="login-container">
      <div class="login-header">
        <van-icon name="user-o" size="60" color="#1989fa" />
        <h2>欢迎登录</h2>
      </div>

      <van-form @submit="onSubmit" class="login-form">
        <van-cell-group inset>
          <!-- <van-field v-model="loginForm.username" name="username" label="用户名" placeholder="请输入用户名"
            :rules="[{ required: true, message: '请输入用户名' }]" /> -->
            <van-field
              v-model="loginForm.username"
              name="username"
              label="用户名"
              placeholder="请输入手机号"
              type="tel"
              :rules="[
                { required: true, message: '请输入手机号' },
                { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' }
              ]"
            />
          <!-- 添加密码输入框 -->
          <!-- <van-field v-model="loginForm.password" type="password" name="password" label="密码" placeholder="请输入密码"
            :rules="[{ required: true, message: '请输入密码' }]" /> -->
        </van-cell-group>
         <div class="login-footer">
          <van-icon name="info-o" size="16" style="vertical-align: middle; margin-right: 4px;" />
          <span>使用手机号一键登录，未注册用户将自动注册登录</span>
        </div>
        <div class="login-buttons">
          <van-button round block type="primary" native-type="submit" :loading="isLoading">
            {{ isLoading ? '登录中...' : '一键登录' }}
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import * as api from '@/utils/api.js'

export default {
  name: 'LoginPage',
  data () {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      isLoading: false
    }
  },
  methods: {
    async onSubmit (values) {
      this.isLoading = true

      if (typeof api.loginList !== 'function') {
        this.$toast.fail('登录功能未正确配置')
        this.isLoading = false
        return
      }

      try {
        // 调用登录接口
        const response = await api.loginList({
          name: values.username,
          phone: values.password
        })

        console.log('登录响应:', response)

        // 保存用户信息到本地存储
        const userInfo = {
          id: response.id || 1,
          name: values.username
        }

        localStorage.setItem('userInfo', JSON.stringify(userInfo))
        this.$toast.success('登录成功')

        // 返回个人中心页面
        this.$router.back()
      } catch (error) {
        console.error('登录错误:', error)
        this.$toast.fail(error.message || '登录失败，请稍后重试')
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.login-container {
  padding: 20px;
}

.login-header {
  text-align: center;
  margin: 30px 0;
}

.login-header h2 {
  margin: 15px 0;
  color: #333;
}

.login-form {
  background: white;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 20px;
}

.login-buttons {
  margin: 20px 0;
}

.login-footer {
  text-align: center;
  color: #999;
  font-size: 14px;
  background-color: #f0f8ff;
  border-radius: 6px;
  padding: 12px 16px;
  margin: 15px 0;
  border-left: 4px solid #1989fa;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue